// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/bouncing-recovery.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/bouncing-recovery/bouncing-recovery.js';
import g1 from '../lessons/aeronautics/bouncing-recovery/porpoising-recovery.js';

mount([g0, g1]);
